//=====================================================
//　パスワードテキストボックスベース
//=====================================================

import { useFormContext } from "react-hook-form"
import { useState } from 'react';

interface IFProps {
    name: string,
    className: string,
    placeholder?: string,
    validations?: {}
}

export function InputPasswordBase(props: IFProps) {
    // パスワード表示制御用のstate
    const [isRevealPassword, setIsRevealPassword] = useState(false);
  
    function togglePassword(){
        setIsRevealPassword(!isRevealPassword);
    }
    const cf = useFormContext();

    //クラス名設定。対象にエラーがある場合はis-errorを付与。
    let tmpClass = props.className;
    if (cf.formState.errors[props.name]){
        tmpClass = tmpClass + " is-error";
    }

    return (
        <>
        <input type={isRevealPassword ? 'text' : 'password'} autoComplete="off" id={props.name} className={tmpClass} placeholder={props.placeholder} {...cf.register(props.name, props.validations)}></input>
        <span
            onClick={function(){
                togglePassword();
            }}
            className={isRevealPassword ? "login-password-invisible":"login-password-visible"  }
        ></span>
        </>
    )

}